import React, { useState, useEffect } from 'react';
import { Modal, Spin, message } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import AcademiaRegister from '../auth/AcademiaRegister';
import academiaApi from '../../api/academiaApi';

const EditAcademiaProfile = ({ visible, onClose, onSuccess, academiaData: initialData }) => {
  const [loading, setLoading] = useState(true);
  const [academiaData, setAcademiaData] = useState(null);

  useEffect(() => {
    if (visible) {
      if (initialData) {
        setAcademiaData(initialData);
        setLoading(false);
      } else {
        fetchAcademiaData();
      }
    }
  }, [visible, initialData]);

  const fetchAcademiaData = async () => {
    try {
      setLoading(true);
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      
      console.log('UserInfo in EditAcademiaProfile:', userInfo);
      console.log('Academia ID:', userInfo.academia);
      
      if (userInfo.academia) {
        const data = await academiaApi.getAcademiaProfile(userInfo.academia);
        console.log('Fetched academia data:', data);
        setAcademiaData(data);
      } else {
        console.error('No academia ID in userInfo:', userInfo);
        message.error('No academia ID found. Please logout and login again to refresh your session.');
        onClose();
      }
    } catch (error) {
      message.error('Failed to load academia data');
      console.error('Error fetching academia data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSuccess = () => {
    message.success('Profile updated successfully!');
    if (onSuccess) onSuccess();
    onClose();
  };

  return (
    <Modal
      title="Edit Academia Profile"
      open={visible}
      onCancel={onClose}
      footer={null}
      width={1100}
      centered
      destroyOnClose
      bodyStyle={{ 
        maxHeight: '80vh', 
        overflowY: 'auto',
        padding: '24px'
      }}
    >
      {loading ? (
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          minHeight: '200px' 
        }}>
          <Spin indicator={<LoadingOutlined style={{ fontSize: 48, color: '#3C007A' }} spin />} />
        </div>
      ) : (
        <AcademiaRegister 
          editingAcademia={academiaData} 
          onSuccess={handleSuccess}
        />
      )}
    </Modal>
  );
};

export default EditAcademiaProfile;
